export default "__VITE_ASSET__726a42a6__"